import request from '../request'

export default {
  getRecursoRecursoTipo: () => {
    return request.get('recurso_recurso_tipo')
  }
}
